import { memo, ReactNode } from "react";
import styled from "styled-components";

const StyledText = styled.div`
  margin-bottom: 30px;
  text-align: center;
  padding: 0 10px;
  color: gray;
`;

interface InfoTextProps {
  children: ReactNode;
}

const InfoText = (props: InfoTextProps) => {
  const { children } = props;

  return <StyledText>{children}</StyledText>;
};

export default memo(InfoText);
